import React from 'react';
import HomeLogo from '../../../elements/HomeLogo';
import EventDate from '../EventDate/EventDate';

/**
 * Renders the event details including logo, name, and date.
 *
 * @param {Object} props - the properties object containing the event details
 * @return {JSX.Element} the rendered event details component
 */
function AddEventWithCodeHeader(props) {
    const {event} = props;

    if (!event) return <HomeLogo />;

    return (
        <>
            <div>
                <img
                    src={event.logo_url}
                    style={{
                        width: '100%',
                    }}
                />
                <h1>{event.name}</h1>

                <EventDate event={event} />
            </div>
            <hr />
        </>
    );
}

export default AddEventWithCodeHeader;
